import { z } from 'zod';

const englishIqChoiceV2Schema = z.object({
  id: z.string().min(1),
  text: z.string().min(1),
});

const englishIqBaseItemV2Shape = {
  family: z.string().min(1),
  id: z.string().min(1),
  prompt: z.string().min(1),
};

const englishIqMediaV2Schema = z.object({
  replayLimit: z.literal(2),
  url: z.string().url(),
});

export const englishIqItemV2Schema = z.discriminatedUnion('type', [
  z.object({
    ...englishIqBaseItemV2Shape,
    choices: z.array(englishIqChoiceV2Schema).min(2).max(4),
    skill: z.enum(['grammar', 'meaning']),
    type: z.literal('choice'),
  }),
  z.object({
    ...englishIqBaseItemV2Shape,
    skill: z.literal('grammar'),
    tokens: z.array(englishIqChoiceV2Schema).min(2),
    type: z.literal('reorder'),
  }),
  z.object({
    ...englishIqBaseItemV2Shape,
    sentence: z.string().includes('___'),
    skill: z.literal('grammar'),
    type: z.literal('typed_cloze'),
  }),
  z.object({
    ...englishIqBaseItemV2Shape,
    choices: z.array(englishIqChoiceV2Schema).min(2).max(4),
    media: englishIqMediaV2Schema,
    skill: z.literal('listening'),
    type: z.literal('audio_choice'),
  }),
  z.object({
    ...englishIqBaseItemV2Shape,
    choices: z.array(englishIqChoiceV2Schema).min(2).max(4),
    media: englishIqMediaV2Schema,
    skill: z.literal('listening'),
    type: z.literal('video_choice'),
  }),
]);

export type IEnglishIqItemV2 = z.infer<typeof englishIqItemV2Schema>;
